<p-drawer
  [visible]="menuNavegacaoDrawerAtivo()"
  (onHide)="onDrawerHide()"
  position="left"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  [blockScroll]="true"
  [modal]="true"
  [dismissible]="true"
  styleClass="w-[min(100vw,20rem)] sm:w-[22rem]"
  [closable]="true"
>
  <div class="flex flex-col -m-4 h-full max-h-dvh">
    <div
      class="flex gap-2 justify-between items-start px-1 pb-3 border-b border-surface-200 dark:border-surface-700 shrink-0"
    >
      <div class="flex-1 pr-2 min-w-0">
        @if (store.carregandoEntrada()) {
          <p-skeleton width="70%" height="1.1rem" styleClass="mb-1" />
          <p-skeleton width="50%" height="0.85rem" />
        } @else if (store.entrada(); as entrada) {
          <span class="text-sm font-semibold leading-tight line-clamp-2">{{ entrada.paciente.nome }}</span>
          <span class="block mt-0.5 text-xs text-surface-500">{{ nomeLeito(entrada) }}</span>
        } @else {
          <span class="text-sm font-semibold">Prontuário</span>
        }
      </div>
    </div>
    <div class="px-2 py-2 border-b shrink-0 border-surface-200 dark:border-surface-700">
      <p-iconfield class="w-full">
        <p-inputicon class="pi pi-search" />
        <input
          type="search"
          pInputText
          placeholder="Buscar no menu"
          class="w-full"
          aria-label="Buscar itens do menu"
          autocomplete="off"
          [value]="store.termoBuscaMenu()"
          (input)="onTermoBuscaMenuAlterado($event)"
        />
      </p-iconfield>
    </div>
    <nav class="lista-menu-scroll overflow-y-auto flex-1 px-1 py-3 mt-2" aria-label="Navegação do prontuário">
      @if (semResultadosBuscaMenu()) {
        <p class="px-2 py-3 m-0 text-sm text-surface-500">Nenhum item encontrado</p>
      }

      @for (bloco of store.itensMenu(); track rastrearBlocoMenu($index, bloco)) {
        @if (bloco.separator) {
          <div class="my-3 border-t border-surface-200 dark:border-surface-700" role="separator"></div>
        } @else {
          @if (bloco.label) {
            <p class="px-2 mb-2 text-xs font-semibold tracking-wide uppercase text-surface-500">{{ bloco.label }}</p>
          }

          <ul class="p-0 m-0 mb-4 list-none">
            @for (sub of bloco.items ?? []; track rastrearItemMenu($index, sub)) {
              <li class="mb-1">
                @if (sub.routerLink && !sub.items) {
                  <a
                    [routerLink]="sub.routerLink"
                    [routerLinkActive]="'bg-surface-100 dark:bg-surface-800 text-primary'"
                    [routerLinkActiveOptions]="sub.routerLinkActiveOptions ?? { exact: true }"
                    [class.opacity-50]="sub.disabled === true"
                    [class.pointer-events-none]="sub.disabled === true"
                    [attr.title]="sub.tooltip ?? null"
                    [attr.aria-disabled]="sub.disabled === true"
                    tabindex="0"
                    (click)="aoNavegar()"
                    class="flex gap-3 items-center px-3 py-2 no-underline rounded-md transition-colors outline-none text-inherit hover:bg-surface-100 dark:hover:bg-surface-800 focus-visible:ring-2 focus-visible:ring-primary"
                  >
                    @if (sub.icon) {
                      @if (ehIconeMaterial(sub.icon)) {
                        <span [class]="obterClassesFonteIconeMaterial(sub.icon)" aria-hidden="true">{{
                          obterGlifoIconeMaterial(sub.icon)
                        }}</span>
                      } @else {
                        <i [ngClass]="sub.icon" class="text-base shrink-0" aria-hidden="true"></i>
                      }
                    }
                    <span class="flex-1 min-w-0 text-sm font-medium leading-snug">{{ sub.label }}</span>
                    @if (sub.badge) {
                      <p-badge [value]="sub.badge" severity="contrast" styleClass="shrink-0" />
                    }
                  </a>
                } @else if (sub.command) {
                  <button
                    type="button"
                    [disabled]="sub.disabled === true"
                    [attr.title]="sub.tooltip ?? null"
                    (click)="executarComando(sub, $event)"
                    class="flex gap-3 items-center px-3 py-2 w-full text-left bg-transparent rounded-md border-0 transition-colors cursor-pointer outline-none text-inherit hover:bg-surface-100 dark:hover:bg-surface-800 disabled:opacity-50 disabled:pointer-events-none focus-visible:ring-2 focus-visible:ring-primary"
                  >
                    @if (sub.icon) {
                      @if (ehIconeMaterial(sub.icon)) {
                        <span [class]="obterClassesFonteIconeMaterial(sub.icon)" aria-hidden="true">
                          {{ obterGlifoIconeMaterial(sub.icon) }}
                        </span>
                      } @else {
                        <i [ngClass]="sub.icon" class="text-base shrink-0" aria-hidden="true"></i>
                      }
                    }
                    <span class="flex-1 min-w-0 text-sm font-medium leading-snug">{{ sub.label }}</span>
                  </button>
                }
              </li>
            }
          </ul>
        }
      }
    </nav>
  </div>
</p-drawer>
